/**
 * @generated SignedSource<<fa68914e7910041674a3890f7e076cb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VerifyEmailSignupPageQuery$variables = {
  id: string;
};
export type VerifyEmailSignupPageQuery$data = {
  readonly node: {
    readonly emailCanResendAt?: string;
    readonly id: string;
  };
};
export type VerifyEmailSignupPageQuery = {
  response: VerifyEmailSignupPageQuery$data;
  variables: VerifyEmailSignupPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailCanResendAt",
      "storageKey": null
    }
  ],
  "type": "EmailSignupRequest",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyEmailSignupPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyEmailSignupPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f1c0ae810f175e7c0cd82c0c52dbd71e",
    "id": null,
    "metadata": {},
    "name": "VerifyEmailSignupPageQuery",
    "operationKind": "query",
    "text": "query VerifyEmailSignupPageQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ... on EmailSignupRequest {\n      emailCanResendAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba014a93e8906451407b13a640bbff4f";

export default node;
